import { View } from "@/components/ui/view";
import React, { useState } from 'react';
import { FlatList } from "react-native-gesture-handler";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSelector } from "react-redux";
import Footer from "@/components/basic/Footer";
import WorkflowListElement from '@/components/workflow/WorkflowListElement';
import { switchScreen } from '@/hooks/navigate';

export default function PrintSelect({ navigation, route }) {
    const insets = useSafeAreaInsets();
    const server = useSelector((state) => state.server)
    const workflows = useSelector((state) => state.workflows)
    const wfMap = useSelector((state) => state.wfMap || [])
    const published = useSelector((state) => state.published || [])
    const [selected, setSelected] = useState([])

    const data = published.filter(share => wfMap[share.workflow.id])

    const onPress = (taskid) => {
    }

    const onSelect = (taskid, isSelected) => {
        if (isSelected) {
            setSelected(prev => {
                const next = [...prev]
                next.push(taskid)
                return next
            })
        } else {
            setSelected(prev => {
                const next = prev.filter(id => id != taskid)
                return next
            })
        }
    }

    const inaUrl = 'https://ina.coach/starter/?qr=';
    const generatePDF = () => {
        if (selected.length > 0) {
            const codes = published.filter(share => selected.includes(wfMap[share.workflow.id])).map(share => ({ data: inaUrl + share.id, text: workflows[wfMap[share.workflow.id]].title }))
            switchScreen(navigation, 'PrintQRCode', { codes: codes, single: false })    
        }
    }

    const renderItem = ({ item, index }) => {
        const taskid = wfMap[item.workflow.id]
        return <WorkflowListElement navigation={navigation} taskid={taskid} avatar={item.image?.id} showProgress={false} showTimer={false} onPress={onPress} selected={selected.includes(taskid)} onSelect={server.online ? onSelect : null} />
    }

    return (
        <View className="bg-secondary-50 flex-1">
            <FlatList
                contentContainerStyle={{ paddingBottom: 120 + insets.bottom }}
                data={data}
                renderItem={renderItem}
                keyExtractor={item => item?.id}
            />
            <Footer navigation={navigation} button={server.online ? { action: generatePDF, info: 'shareQRCode.genPDF' } : null} />
        </View>
    );
}